<template>
    <div v-if="isLoading" class="loading-overlay"><p>Carregando...</p></div>
    <div v-if="msgAlerta" class="info-alert row-space">{{ msgAlerta }}</div>

    <div class="form-edit-page row row-space">
        <div class="form-item-rangedata"><RangeDataSelect :periodoInicial="'currentYear'" v-model="dateRange"/></div>
        <EstabelecimentoSelect :ckAddTodos="true" v-model:idSelecionado="estabelecimentoSelecionado" />
        <TpDocSelect :ckAddTodos="true" v-model:idSelecionado="tpdocSelecionado" />
        <button type="button" class="buttom-icon--search" @click="lerDados" />
        <button type="button" class="buttom-icon--close" @click="closePage" />
    </div>

    
    <div v-if="lsDados.length>0" class="table-wrapper"><table>
        <thead><tr>
            <th class="col-width-char10">Data</th>
            <th class="col-width-char30">Tipo</th>
            <th>Estabelecimento</th>
            <th class="col-width-char10">Validade</th>
            <th class="col-width-char20">Situação</th>
            <th class="col-width-char10">Ações</th>
        </tr></thead>

        <tbody>
            <tr v-for="(obj, index) in lsDados" :key="obj.idregistro" :class="{'even-row': index % 2 === 0, 'odd-row': index % 2 !== 0}">
                <td class="col-width-char10">{{ Funcoes.formatDateFromJson(obj.dtanexo) }}</td>
                <td class="col-width-char30">{{ obj.nmtpdoc }}</td>
                <td>{{ obj.nmestabelecimento }}</td>
                <td class="col-width-char10">{{ Funcoes.formatDateFromJson(obj.dtvalidade) }}</td>
                <td class="col-width-char20">{{ obj.situacaonm }}</td>
                <td class="col-width-char10"><div class="row-left">
                    <button class="btn-icon btn-icon--pdf" @click="lerAnexo(obj)"></button>
                    <button v-if="obj.situacao === 1" class="btn-icon btn-icon--checkMark" @click="openAnalise(obj)"></button>
                </div></td>
            </tr>
        </tbody>
    </table></div>


    <div v-if="showAnalise" class="modal-overlay">
        <div class="modal-content">
            <h4>Análise de Documentação</h4>
            <form>
                <div class="form-group">
                    <div class="form-item">
                        <label class="label-caption">Data de Validade:</label>
                        <input type="date" v-model="dtValidade" required />
                    </div>
                </div>

                <div class="form-group">
                    <div class="form-item">
                        <label class="label-caption">Justificativa</label>
                        <textarea v-model="obsAnalise" maxlength="1000" rows="5" style="resize: none;" required/>
                    </div>
                </div>

                <div class="buttons form-group">
                    <button type="button" class="btn-confirm" @click="salvarAnalise('S')">APROVAR</button>
                    <button type="button" class="btn-cancel" @click="salvarAnalise('N')">NÃO APROVAR</button>
                </div>

                <div class="buttons">
                    <button @click="showAnalise = false">SAIR</button>
                </div>
            </form>
        </div>
    </div>
</template>

<script setup>
import { ref, onMounted } from 'vue';
import { Api } from '@/funcoes/apiExport';
import { Funcoes } from '@/funcoes/funcoes';
import { globalStore } from '@/globals';
import { Validar } from '@/funcoes/validacoes';
import EstabelecimentoSelect from '../selects/EstabelecimentoSelect.vue';
import RangeDataSelect from '@/components/selects/RangeDataSelect.vue';
import TpDocSelect from '../selects/TpDocSelect.vue';

const emit = defineEmits(['close']);

const dateRange = ref({ startDate: "", endDate: "", selectedPeriod: "" });
const dtValidade = ref(null);
const estabelecimentoSelecionado = ref(null);
const isLoading = ref(false);
const lsDados = ref([]);
const msgAlerta = ref(null);
const objSelecionado = ref(null);
const obsAnalise = ref('');
const showAnalise = ref(false);
const tpdocSelecionado = ref(null);


const closePage = () => {emit('close');}

const lerAnexo = async(obj) => {
    try {
        msgAlerta.value = null;
        isLoading.value = true;
        if (obj.storage_cdtipo === 2){
            const r = await Api.genericPost('/operacoes/solicitar/download', {id: obj.id});
            if (r.bolok === 1){
                const url = r.download_url;
                window.open(url, '_blank');
            }
        }else{
            const response = await Api.genericAnexo(obj.id);
            const pdfBlob = new Blob([response], { type: 'application/pdf' });
            const pdfUrl = URL.createObjectURL(pdfBlob);
            window.open(pdfUrl, '_blank');
        }
    } catch (error){msgAlerta.value = `ATENÇÃO: ${error.message}`;
    } finally {isLoading.value = false;}
};

async function lerDados() {
    const r = Validar.intervaloDatas(dateRange.value.startDate, dateRange.value.endDate);
    if (!r.ok){msgAlerta.value = r.msg; return;}

    try{
        msgAlerta.value = null;
        isLoading.value = true;
        const dados = {
            idep: globalStore.idep,
            idsim: globalStore.idsim,
            idestabelecimento: (estabelecimentoSelecionado.value ? estabelecimentoSelecionado.value : 0),
            intparam1: 1,
            intparam2: tpdocSelecionado.value,
            datainicial: dateRange.value.startDate,
            datafinal: dateRange.value.endDate
        };
        const req = await Api.genericPost('/listas/anexos', dados);
        lsDados.value = req;
    } catch (error){msgAlerta.value = `ATENÇÃOx: ${error.message}`;
    } finally {isLoading.value = false;}
}

const openAnalise = (obj) => {
    objSelecionado.value = obj;
    dtValidade.value = obj.dtvalidade;
    obsAnalise.value = null;
    showAnalise.value = true;
}

const salvarAnalise = async(aprovadoSN) => {
    msgAlerta.value = null;
    if (!dtValidade.value){alert('Necessário informar data de validade!'); return;}
    if (!obsAnalise.value){alert('Necessário informar justificativa'); return;}
    try{
        try {
            const dados = {
                id: objSelecionado.value.id,
                dhanalise : Funcoes.strDataHoraAtual(),
                idloginanalise: globalStore.idlogin,
                iduanalise: globalStore.id,
                obsanalise: obsAnalise.value,
                homologado: aprovadoSN
            };
            const ret = await Api.genericPut('/cad/anexo', dados);
            if (ret.bolok == 0){
                msgAlerta.value = `ATENÇÃO: ${ret.erro}`;
            }else{
                await lerDados();
                showAnalise.value = false;
            }
        } catch (error) {
            alert(error);
        }
    } catch (error){msgAlerta.value = `ATENÇÃO: ${error.response?.data || error.message}`;
    }finally{isLoading.value = false;}
}

onMounted(lerDados)
</script>